import { useInfiniteQuery, useQuery, useQueryClient } from '@tanstack/react-query'

//TODO: some pagination and filtering is required, in this case will switch later to useInfinite scroll, this is test only
export const queryShowcases = (params) => { 

    const query = useQuery({
        queryKey: ['get-studio-showcases', params],
        queryFn: async () => {
            const { data } = await axios.get(route('studio.editor.api.showcases.index'), {
                params
            });
            return data || [];
        },
    });

    return query;
}

export const infiniteShowcases = (params) => {

    const pageSize = 30;

    const shuffleAds = (ads, rowSize) => {
        const adsByTemplate = {};
        const noTemplateAds = [];
    
        for (const ad of ads) {
            const templateId = ad?.ad_showcase?.ad_template_id;
            if (!templateId) {
                noTemplateAds.push(ad);
            } else {
                (adsByTemplate[templateId] ||= []).push(ad);
            }
        }
    
        const templateEntries = Object.entries(adsByTemplate);
        const distributedAds = [];
        const usedTemplates = new Set();
    
        while (templateEntries.length || noTemplateAds.length) {
            let row = [];
            usedTemplates.clear();
    
            for (let i = 0; i < rowSize; i++) {
                if (templateEntries.length) {
                    let index = templateEntries.findIndex(([id]) => !usedTemplates.has(id));
                    if (index !== -1) {
                        let [templateId, adList] = templateEntries[index];
                        row.push(adList.shift());
                        usedTemplates.add(templateId);
    
                        if (!adList.length) {
                            templateEntries.splice(index, 1);
                        }
                        continue;
                    }
                }
    
                if (noTemplateAds.length) {
                    row.push(noTemplateAds.shift());
                }
            }
    
            distributedAds.push(...row);
        }
    
        return distributedAds;
    };
    
    

    const query = useInfiniteQuery({
        queryKey: ['get-studio-showcases-infinite', params],
        queryFn: async ({ pageParam }) => {
            const { data } = await axios.get(route('studio.editor.api.showcases.index'), {
                params: {
                    ...params,
                    start: pageParam * pageSize,
                    length: pageSize,
                }
            });
            if(data){
                // return {
                //     ...data,
                //     data: shuffleAds(data?.data, 3)
                // }

                return {
                    ...data,
                    data: data?.data
                }
            }
            return [];
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, allPages, lastPageParam) => {

            if((lastPageParam * pageSize) >= (lastPage.recordsFiltered - pageSize)){
                return undefined;
            }

            return lastPageParam + 1
        },
    });

    return { ...query, pageSize };
}

export const usePrefetchShowcases = () => {
    const queryClient = useQueryClient();

    const prefetchShowcases = async (prefetchParams) => {
        const queryKey = ['get-studio-showcases', prefetchParams];
        const cachedData = queryClient.getQueryData(queryKey);

        // Only prefetch if the data doesn't already exist in the cache
        if (!cachedData) {
            await queryClient.prefetchQuery({
                queryKey,
                queryFn: async () => {
                    const { data } = await axios.get(route('studio.editor.api.showcases.index'), {
                        params: prefetchParams,
                    });
                    return data || [];
                },
            });
        }
    };

    return prefetchShowcases;
};
